import { jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';

const Styles = labelStyles("Spacer", {
  root: (props) => [
    {
      label: `${props.width || 0}-by-${props.height || 0}`,
      width: props.width,
      height: props.height
    }
  ]
});
const Spacer = ({ width = 0, height = 0 }) => {
  return jsx("div", { css: Styles.root({ width, height }), "data-zds": true });
};

export { Spacer };
//# sourceMappingURL=Spacer.es.js.map
